import {
    esc,
    shortName,
} from "../shared/viewer-utils";
import { bracketrBirthdayFor } from "../shared/site-milestones";

"use strict";
(() => {
    const birthday = bracketrBirthdayFor();
    if (birthday.isBirthday) {
        const ordinal = birthday.age % 100 >= 11 && birthday.age % 100 <= 13
            ? "th"
            : ({ 1: "st", 2: "nd", 3: "rd" }[birthday.age % 10] || "th");
        const banner = document.createElement("aside");
        banner.className = "bracketr-birthday";
        banner.setAttribute("aria-label", "Bracketr birthday celebration");
        banner.innerHTML = `<span aria-hidden="true">&#127881;</span><strong>It&rsquo;s Bracketr&rsquo;s ${birthday.age}${ordinal} birthday!</strong><small>Launched 29 May 2026</small>`;
        document.querySelector(".topbar")?.insertAdjacentElement("afterend", banner);
    }
    const section = document.getElementById("homeLiveSection");
    const grid = document.getElementById("homeLiveGrid");
    const eventGrid = document.getElementById("homeEventGrid");
    if (!section || !grid)
        return;
    function eventMeta(event) {
        return [event.org, event.gameTitle, event.region].filter(Boolean).join(" • ") || "Live event";
    }
    function logoMarkup(src, label) {
        if (src)
            return `<img src="${esc(src)}" alt="${esc(label || "")}" loading="lazy" decoding="async">`;
        return `<div class="avatar-chip">${esc(shortName(label))}</div>`;
    }
    function eventUrl(event) {
        const leagueId = event.leagueId || event.id || event.eventId || event.seriesId;
        if (leagueId)
            return `/series?leagueId=${encodeURIComponent(leagueId)}`;
        return "/whats-on";
    }
    function formatEventDate(event) {
        const days = Array.isArray(event.gameDays) ? event.gameDays : [];
        const today = String(event.currentDate || "");
        const next = days
            .filter((day) => day?.date && (!today || String(day.date) >= today))
            .sort((a, b) => String(a.date).localeCompare(String(b.date)))[0];
        if (!next?.date)
            return "Schedule in match hub";
        const parsed = new Date(`${next.date}T00:00:00`);
        const date = Number.isNaN(parsed.getTime())
            ? String(next.date)
            : parsed.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" });
        return `${date}${next.time ? ` · ${String(next.time).slice(0, 5)}` : ""}${event.timezoneLabel ? ` ${event.timezoneLabel}` : ""}`;
    }
    function renderEventCard(event) {
        const logo = event.logo || event.gameLogo;
        return `
      <a class="home-event-card" href="${esc(eventUrl(event))}">
        <div class="home-event-card-top">
          <div class="home-event-logo">${logoMarkup(logo, event.name)}</div>
          <span class="home-event-state">${event.liveStreams?.length ? "Live now" : "In action"}</span>
        </div>
        <div>
          <h3>${esc(event.name || "Competition")}</h3>
          <p>${esc(eventMeta(event))}</p>
        </div>
        <div class="home-event-next"><span>Next match day</span><strong>${esc(formatEventDate(event))}</strong></div>
        <div class="home-event-open">Open match hub <span>→</span></div>
      </a>`;
    }
    function primaryStream(event) {
        const streams = Array.isArray(event.liveStreams) ? event.liveStreams : [];
        const cards = [];
        streams.forEach((stream) => {
            const matches = Array.isArray(stream.matches) ? stream.matches : [];
            const firstMatch = matches[0] || {};
            const streamer = stream.streamer || {};
            cards.push({ stream, streamer, firstMatch, matchCount: matches.length });
        });
        return cards;
    }
    function renderCard(event, streamInfo, index) {
        const { stream, streamer, firstMatch, matchCount } = streamInfo;
        const streamerName = streamer.name || `Stream ${stream.streamNumber || index + 1}`;
        const logo = event.logo || event.gameLogo;
        const time = firstMatch.time ? ` • ${esc(firstMatch.time)}${event.timezoneLabel ? ` ${esc(event.timezoneLabel)}` : ""}` : "";
        const round = firstMatch.roundName || "Live match";
        const teams = [firstMatch.team1, firstMatch.team2].filter(Boolean).join(" vs ");
        const href = streamer.url || eventUrl(event);
        return `
      <article class="stream-card real-stream-card">
        <a class="stream-card-link" href="${esc(href)}"${streamer.url ? ' target="_blank" rel="noopener"' : ""}>
          <div class="stream-art art-${(index % 3) + 1}">
            <span class="live-badge">LIVE</span>
            <span class="viewer-count">${matchCount > 1 ? `${matchCount} matches` : "Now"}</span>
          </div>
          <div class="stream-body">
            <div class="event-row">
              ${logoMarkup(logo, event.name)}
              <div>
                <h3>${esc(event.name)}</h3>
                <p>${esc(eventMeta(event))}</p>
              </div>
            </div>
            <div class="stream-meta">
              <strong>Stream ${esc(stream.streamNumber || index + 1)}: ${esc(streamerName)}</strong>
              <span>${esc(round)}${time}</span>
              ${teams ? `<small>${esc(teams)}</small>` : ""}
            </div>
          </div>
        </a>
      </article>
    `;
    }
    async function loadHomeContent() {
        try {
            const response = await fetch("/api/public/whats-on");
            if (!response.ok)
                throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            const liveEvents = Array.isArray(data.liveNow) ? data.liveNow : [];
            const activeEvents = Array.isArray(data.eventsInAction) ? data.eventsInAction : [];
            const cards = [];
            liveEvents.forEach((event) => {
                primaryStream(event).forEach((streamInfo) => {
                    if (cards.length < 3)
                        cards.push(renderCard(event, streamInfo, cards.length));
                });
            });
            if (!cards.length) {
                section.hidden = true;
                grid.innerHTML = "";
            }
            else {
                grid.innerHTML = cards.join("");
                section.hidden = false;
            }
            if (eventGrid) {
                eventGrid.innerHTML = activeEvents.length
                    ? activeEvents.slice(0, 3).map(renderEventCard).join("")
                    : `<article class="home-event-card home-event-empty"><p class="eyebrow">Between rounds</p><h3>No competitions are in action right now.</h3><a href="/whats-on">See what's coming up →</a></article>`;
            }
        }
        catch (error) {
            section.hidden = true;
            grid.innerHTML = "";
            if (eventGrid)
                eventGrid.innerHTML = `<article class="home-event-card home-event-empty">Competition discovery is temporarily unavailable.</article>`;
        }
    }
    function startLiveSocket() {
        if (!("EventSource" in window)) {
            setInterval(loadHomeContent, 60000);
            return;
        }
        const source = new EventSource("/api/public/events");
        source.addEventListener("match-updated", loadHomeContent);
        source.addEventListener("league-updated", loadHomeContent);
        source.addEventListener("applications-updated", loadHomeContent);
        source.onerror = () => {
            setTimeout(loadHomeContent, 15000);
        };
    }
    loadHomeContent();
    startLiveSocket();
})();
//# sourceMappingURL=home.js.map
